import {useRef, useState} from 'react';

const TOUCH_END_DELAY = 100;

export function useRatingPreview() {
  const [hoverValue, setHoverValue] = useState<number | undefined>(undefined);
  const isTouchDevice = useRef(false);

  const handleContainerMouseLeave = () => {
    setHoverValue(undefined);
  };

  const handleStarMouseEnter = (optionValue: number) => {
    if (!isTouchDevice.current) {
      setHoverValue(optionValue);
    }
  };

  const handleTouchStart = (optionValue: number) => {
    isTouchDevice.current = true;
    setHoverValue(optionValue);
  };

  const handleTouchEnd = () => {
    setTimeout(() => {
      setHoverValue(undefined);
    }, TOUCH_END_DELAY);
  };

  return {
    hoverValue,
    handleContainerMouseLeave,
    handleStarMouseEnter,
    handleTouchStart,
    handleTouchEnd,
  };
}
